import React, { useState, useEffect, useRef } from "react";
import { PiLightningFill, PiSpinnerBallDuotone } from "react-icons/pi";
import { useUser } from "../context/userContext";
import { IoCheckmarkCircleSharp, IoClose } from "react-icons/io5";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase/firestore";
import {
  TonConnectButton,
  TonConnectError,
  useTonConnectUI,
  useTonWallet,
} from "@tonconnect/ui-react";

const SlotMachine = () => {
  const SLOT_VALUES = [
    { value: 1, image: "/1.png" },
    { value: 2, image: "/2.png" },
    { value: 3, image: "/3.png" },
    { value: 4, image: "/4.png" },
    { value: 5, image: "/5.png" },
  ];
  const WIN_PROBABILITY = 0.35;

  const REWARDS = {
    ROULETTE_SPINS: {
      probability: 0.35,
      options: [
        { probability: 0.2, value: 5 },
        { probability: 0.2, value: 10 },
        { probability: 0.2, value: 15 },
        { probability: 0.2, value: 15 },
        { probability: 0.1, value: 25 },
        { probability: 0.05, value: 35 },
        { probability: 0.04, value: 50 },
        { probability: 0.01, value: 100 },
      ],
    },
    CHEESE_POINTS: {
      probability: 0.35,
      options: [
        { probability: 0.35, value: 1000 },
        { probability: 0.25, value: 2500 },
        { probability: 0.15, value: 5000 },
        { probability: 0.1, value: 7500 },
        { probability: 0.05, value: 10000 },
        { probability: 0.05, value: 15000 },
        { probability: 0.04, value: 20000 },
        { probability: 0.01, value: 50000 },
      ],
    },
    MULTIPLIER: {
      probability: 0.3,
      options: [
        { probability: 0.2, value: 2 },
        { probability: 0.2, value: 5 },
        { probability: 0.2, value: 7 },
        { probability: 0.1, value: 10 },
        { probability: 0.05, value: 15 },
        { probability: 0.04, value: 20 },
        { probability: 0.01, value: 25 },
      ],
    },
    CASINO_SLOTS: {
      probability: 0.3,
      options: [
        { probability: 0.3, value: 1 },
        { probability: 0.3, value: 3 },
        { probability: 0.1, value: 5 },
        { probability: 0.1, value: 7 },
        { probability: 0.1, value: 10 },
        { probability: 0.05, value: 15 },
        { probability: 0.02, value: 20 },
        { probability: 0.02, value: 25 },
        { probability: 0.01, value: 50 },
      ],
    },
  };

  const tMax = 3000; // animation time, ms
  const height = 210;

  const [speeds, setSpeeds] = useState([]);
  const [r, setR] = useState([]);
  const [msg, setMsg] = useState("Press Spin to start");
  const [start, setStart] = useState(undefined);
  const [points, setPoints] = useState(0); // State for user's points
  const $reelsRef = useRef([]);
  const animationFrameId = useRef(null);
  const [openModal, setOpenModal] = useState(false);
  const {
    id,
    balance,
    tapValue,
    setBalance,
    spinLimit,
    setSpinLimit,
    energy,
    setEnergy,
    multiplierSpin, // bright added this
    setMultiplierSpin, // bright added this
  } = useUser();
  const modalRef = useRef(null);
  const [openClaim, setOpenClaim] = useState(false);
  const [congrats, setCongrats] = useState(false);
  const [message, setMessage] = useState("");
  const [messageColor, setMessageColor] = useState("");
  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(true);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [openUpgrade, setOpenUpgrade] = useState(false);
  const [openUpgradeTwo, setOpenUpgradeTwo] = useState(false);
  const [showCongratsModal, setShowCongratsModal] = useState(false);
  const [congratsMessage, setCongratsMessage] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [buttonText, setButtonText] = useState("Make Purchase");
  const [slots, setSlots] = useState([
    SLOT_VALUES[1],
    SLOT_VALUES[1],
    SLOT_VALUES[1],
  ]);
  const [cheese, setCheese] = useState(0);

  const wallet = useTonWallet();
  const [tonConnectUI] = useTonConnectUI();

  // Define costs for each option
  const costs = {
    20: 500000000,
    50: 1000000000,
    500: 3000000000,
  };

  // Define spins for each option
  const spins = {
    20: 20,
    50: 50,
    500: 500,
  };
  // Probability of winning (30% chance to win)

  // Bright logic here

  // Utility function to get random number between 0 and 1
  const getRandom = () => Math.random();

  // Utility function to select from weighted options
  const selectFromWeighted = (options) => {
    const random = getRandom();
    let sum = 0;

    for (const option of options) {
      sum += option.probability;
      if (random <= sum) return option.value;
    }

    return options[options.length - 1].value;
  };

  // Determine reward type based on probabilities
  const determineRewardType = () => {
    const random = getRandom();
    if (random <= REWARDS.ROULETTE_SPINS.probability) return "ROULETTE_SPINS";
    if (
      random <=
      REWARDS.ROULETTE_SPINS.probability + REWARDS.MULTIPLIER.probability
    )
      return "MULTIPLIER";
    if (
      random <=
      REWARDS.ROULETTE_SPINS.probability +
        REWARDS.MULTIPLIER.probability +
        REWARDS.CASINO_SLOTS.probability
    )
      return "CASINO_SLOTS";
    return "CHEESE_POINTS";
  };

  // Generate random slot values with animation effect
  const generateSlotValues = () => {
    return new Promise((resolve) => {
      let cycles = 0;
      const maxCycles = 20;
      const interval = setInterval(() => {
        setSlots(
          slots.map(() => {
            const randomIndex = Math.floor(Math.random() * SLOT_VALUES.length);
            return SLOT_VALUES[randomIndex];
          })
        );
        cycles++;

        if (cycles >= maxCycles) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
    });
  };

  const handleSpin = async () => {
    // Guard clauses
    if (start !== undefined || spinLimit <= 0) return;

    try {
      setMsg("Spinning...");
      setStart(performance.now());
      setSpinLimit((prev) => prev - 1);

      // Animate slots
      await generateSlotValues();

      // Early return if no ID
      if (!id) {
        setStart(undefined);
        setMsg("Error: User ID not found");
        return;
      }

      // Determine win condition
      const hasBoost = tapValue.level > 10000;
      const isWin = hasBoost || Math.random() <= WIN_PROBABILITY;

      const rewardType = determineRewardType();
      const reward = selectFromWeighted(REWARDS[rewardType].options);
      const userRef = doc(db, "telegramUsers", id.toString());
      const newSpinLimit = spinLimit - 1;

      if (!isWin) {
        setStart(undefined);
        await updateDoc(userRef, {
          spinLimit: spinLimit - 1,
          slotTimeStamp: new Date(),
        });
        setSpinLimit(newSpinLimit);
        setMsg("No reward! Better luck next time!");
        return;
      }
      // eslint-disable-next-line default-case
      switch (rewardType) {
        case "CHEESE_POINTS":
          await updateDoc(userRef, {
            spinLimit: spinLimit - 1,
            balance: balance + Number(reward),
            slotTimeStamp: new Date(),
          });
          setOpenClaim(true);
          setMsg(`Won ${reward} Cheese Points!`);
          setCheese((prev) => prev + reward);
          setBalance((prev) => prev + Number(reward));
          setSpinLimit(newSpinLimit);
          break;

        case "ROULETTE_SPINS":
          await updateDoc(userRef, {
            spinLimit: spinLimit - 1,
            energy: energy + Number(reward),
            slotTimeStamp: new Date(),
          });
          setOpenClaim(true);
          setEnergy((prev) => prev + Number(reward));
          setMsg(`Won ${reward} Roulette Spins!`);
          setSpinLimit(newSpinLimit);
          break;

        case "MULTIPLIER":
          await updateDoc(userRef, {
            spinLimit: spinLimit - 1,
            multiplierSpin: multiplierSpin + Number(reward),
            slotTimeStamp: new Date(),
          });
          setOpenClaim(true);
          setMultiplierSpin((prev) => prev + Number(reward));
          setMsg(`Won ${reward}spins of 3x Multiplier!`);
          setSpinLimit(newSpinLimit);
          break;

        case "CASINO_SLOTS":
          await updateDoc(userRef, {
            spinLimit: spinLimit - 1 + Number(reward),
            slotTimeStamp: new Date(),
          });
          setOpenClaim(true);
          setSpinLimit((prev) => prev + Number(reward));
          setMsg(`Won ${reward} Casino Slot Spins!`);
          break;
      }

      // setSpinLimit(newSpinLimit);
      setStart(undefined);
    } catch (error) {
      console.error("Error in handleSpin:", error);
      setMsg("An error occurred. Please try again.");
      setStart(undefined);
    }
  };

  const closeModalPay = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setOpenModal(false);
    }
  };

  useEffect(() => {
    if (!id) {
      if (openModal) {
        document.addEventListener("mousedown", closeModalPay);
      } else {
        document.removeEventListener("mousedown", closeModalPay);
      }

      return () => {
        document.removeEventListener("mousedown", closeModalPay);
      };
    }
    // eslint-disable-next-line
  }, [openModal, id]);

  useEffect(() => {
    if (start !== undefined) {
      const animate = (now) => {
        if (!start) setStart(now);
        const t = now - start || 0;

        for (let i = 0; i < 3; ++i) {
          $reelsRef.current[i] =
            ((speeds[i] / tMax / 2) * (tMax - t) * (tMax - t) + r[i]) % height |
            0;
        }

        if (t < tMax) {
          animationFrameId.current = requestAnimationFrame(animate);
        } else {
          setStart(undefined);
          // check();
        }
      };

      animationFrameId.current = requestAnimationFrame(animate);

      return () => {
        if (animationFrameId.current) {
          cancelAnimationFrame(animationFrameId.current);
        }
      };
    }
    // eslint-disable-next-line
  }, [start, speeds, r]);

  // const openClaimer = () => {
  //   setOpenClaim(true);
  //   setCongrats(true);

  //   setTimeout(() => {
  //     setCongrats(false);
  //   }, 4000);
  // };

  const closeClaimer = () => {
    setOpenClaim(false);
    setPoints(0); // Reset points after claiming
  };

  const calculateTimeRemaining = () => {
    const now = new Date();
    const nextDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + 1
    );
    const timeDiff = nextDate - now;

    const hours = Math.floor(timeDiff / (1000 * 60 * 60));
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

    return { hours, minutes, seconds };
  };

  const checkAndResetSpins = async () => {
    const { hours, minutes, seconds } = calculateTimeRemaining();

    if (hours === 0 && minutes === 0 && seconds === 0 && id) {
      try {
        const userRef = doc(db, "telegramUsers", id.toString());
        await updateDoc(userRef, {
          spinLimit: Number(5),
          slotTimeStamp: new Date(),
        });
        setSpinLimit(5); // Update local state
      } catch (error) {
        console.error("Error resetting spins:", error);
      }
    }
  };

  // Initial state
  const [timeRemaining, setTimeRemaining] = useState(calculateTimeRemaining());

  useEffect(() => {
    // Initial check
    checkAndResetSpins();

    // Update time every second
    const interval = setInterval(() => {
      const newTime = calculateTimeRemaining();
      setTimeRemaining(newTime);

      // Check if we need to reset spins
      checkAndResetSpins();
    }, 1000);

    return () => clearInterval(interval);
  }, [id]); // Add id as dependency

  // Now you can safely log timeRemaining
  // console.log(timeRemaining.hours);

  useEffect(() => {
    const initializeTonConnect = async () => {
      try {
        await tonConnectUI.connectionRestored;
        setIsLoading(false);
      } catch (err) {
        console.error("TonConnect initialization error:", err);
        if (err instanceof TonConnectError) {
          setMessage(`TonConnect error: ${err.message}`);
        } else {
          setMessage(
            "An error occurred while connecting to TON. Please refresh the page and try again."
          );
        }
        setMessageColor("red");
        setIsLoading(false);
      }
    };

    initializeTonConnect();
  }, [tonConnectUI]);

  const transaction = (cost) => ({
    validUntil: Math.floor(Date.now() / 1000) + 300, // 5 minutes from now
    messages: [
      {
        address: "UQDGh5a8otuHDyWliJpR8W443enkVOw7v_AJdQsCgkBwTNwt",
        amount: cost, // Cost of the selected card
      },
    ],
  });

  const handleClick = async (cost, spins) => {
    setButtonText("Processing...");
    setButtonDisabled(true);

    try {
      // Send the transaction
      const response = await tonConnectUI.sendTransaction(transaction(cost));
      console.log("Transaction sent successfully");
      console.log("Transaction response:", response);

      const newSpinLimit = spinLimit + spins;

      // Update the user's Firestore document with the purchased card
      const userRef = doc(db, "telegramUsers", id.toString());
      await updateDoc(userRef, {
        spinLimit: newSpinLimit,
      });

      setSpinLimit(newSpinLimit);

      setCongratsMessage(
        <div className="w-full flex justify-center flex-col items-center space-y-3">
          <div className="w-full items-center justify-center flex flex-col space-y-2">
            <PiSpinnerBallDuotone size={16} className="text-accent" />
            <p className="font-medium text-center">Congratulations!</p>
          </div>
          <span className="font-medium text-[18px] text-[#ffffff] pt-2 pb-2 flex items-center space-x-1">
            <PiLightningFill size={18} className="text-[#ffee00]" />
            <span className={`text-accent`}>{spins}</span>{" "}
            <span>GOLD HAND SPIN PURCHASED</span>
          </span>
          <p className="pb-6 text-[15px] w-full text-center">
            More spins, more points, more boosts. Get ready for the cheesy
            omelette! Good luck 😎 'We're going to put these hands in the
            monkeys 🖕' - CATVEGAS
          </p>
        </div>
      );

      // Show the congrats modal
      setShowCongratsModal(true);
      setOpenUpgrade(false);
      setCongrats(true);
      setTimeout(() => {
        setCongrats(false);
      }, 3000);

      // Show a success message
      setMessage("");
      setMessageColor("green");
    } catch (err) {
      console.error("Transaction error:", err);

      if (err instanceof TonConnectError) {
        if (err.message.includes("Operation aborted")) {
          setMessage(
            "Transaction was cancelled or timed out. Please try again."
          );
          setMessageColor("orange");
        } else {
          console.error(`TonConnect error: ${err.message}`);
        }
      } else {
        setMessage("An unexpected error occurred. Please try again.");
        setMessageColor("red");
      }

      if (err.response) {
        console.error("Error response data:", err.response.data);
      }
    } finally {
      // Re-enable the button and reset the text
      setButtonText("Make Purchase");
      setButtonDisabled(false);
    }
  };

  const handlePurchase = () => {
    handleClick(costs[selectedOption], spins[selectedOption]);
  };

  return (
    <>
      <div className="w-full flex flex-col pt-4 !mb-[-6px] px-2">
        <div className="w-full flex justify-between items-center gap-2 border border-borders2 py-3 px-4 rounded-[12px]">
          <button
            onClick={() => setOpenUpgradeTwo(true)}
            className="w-full justify-center items-center p-1 flex flex-col space-y-1 rounded-[8px]"
          >
            <div className="flex space-x-[2px] items-center">
              <img src="/boost.webp" alt="rfdf" className="w-[18px]" />
              <span className="font-semibold boostTitle text-[12px] items-start text-left flex flex-col">
                <span className=""> Buy Gold Hand Spin</span>
              </span>
            </div>
          </button>
        </div>
      </div>

      <div className="w-full flex flex-col space-y-1">
        <div id="sm" className="w-full border border-[2px] border-[#a71414]">
          <div className="w-full flex justify-between items-center pb-2 px-4">
            <div className="flex items-center">
              <span className="flex items-center mt-[-1px]">
                <img
                  src="/cheesetoken.png"
                  className="w-[24px]"
                  alt="engagecoin"
                />
              </span>
              <span className="text-[#fff] font-semibold text-[16px]">
                <span className="pl-[4px]">
                  {cheese} <span className="text-secondary"></span>
                </span>
              </span>
            </div>

            <div className="flex items-center cursor-pointer space-x-1 text-[13px]">
              <PiSpinnerBallDuotone size={16} className="" />
              {spinLimit <= 0 ? (
                <span className="">
                  {timeRemaining.hours ? `${timeRemaining.hours}h ` : ""}
                  {timeRemaining.minutes ? `${timeRemaining.minutes}m ` : ""}
                  {timeRemaining.seconds ? `${timeRemaining.seconds}s` : ""}
                </span>
              ) : (
                <span className="">{spinLimit} spins left</span>
              )}
            </div>
          </div>

          <div className="grid grid-cols-3 gap-2 mb-4">
            {slots.map((slot, index) => (
              <div
                key={index}
                className="aspect-square bg-white rounded-lg flex items-center justify-center"
              >
                <div className="w-[86px] h-[86px] flex items-center justify-center">
                  <img
                    src={slot.image}
                    alt={`Slot value ${slot.value}`}
                    className="w-full h-full object-contain block"
                  />
                </div>
              </div>
            ))}
          </div>

          <p className="text-[15px] w-full text-center pt-4 px-4">{msg}</p>
        </div>

        <div className="w-full flex justify-center items-center relative">
          <div className="w-[100px] h-[100px] bg-[#ba202068] flex items-center justify-center rounded-full">
            {spinLimit <= 0 ? (
              <button
                onClick={() => setOpenModal(true)}
                className={`bg-btn h-[90px] ease-in duration-300 w-[90px] font-bold text-[20px] rounded-full flex items-center justify-center`}
              >
                SPIN
              </button>
            ) : (
              <button
                disabled={start !== undefined || spinLimit <= 0} // Disable the spin button if spins are exhausted
                onClick={handleSpin}
                className={`${
                  start !== undefined ? "bg-[#780E0E] shadowwhite" : "bg-btn"
                } h-[90px] ease-in duration-300 w-[90px] font-bold text-[20px] rounded-full flex items-center justify-center`}
              >
                SPIN
              </button>
            )}
          </div>
        </div>
      </div>

      <div
        className={`${
          openModal ? "flex" : "hidden"
        } fixed bottom-0 left-0 z-40 right-0 h-[100vh] bg-[#303030c4] flex-col justify-end items-center`}
      >
        <div
          ref={modalRef}
          className={`w-full bg-divider shadowtop rounded-tl-[40px] rounded-tr-[40px] relative flex flex-col ease-in duration-300 transition-all justify-center`}
        >
          <div className="w-full flex taskbg rounded-tl-[40px] rounded-tr-[40px] mt-[2px] justify-center relative flex-col items-center space-y-3 p-4 pt-20 pb-10">
            <button
              onClick={() => setOpenModal(false)}
              className="flex items-center justify-center h-[32px] w-[32px] rounded-full bg-[#383838] absolute right-6 top-4 text-center font-medium text-[16px]"
            >
              <IoClose size={20} className="text-[#9995a4]" />
            </button>

            <div className="w-full bg-cards rounded-[16px] py-6 relative px-4 flex flex-col justify-center items-center">
              <PiSpinnerBallDuotone
                size={34}
                className="text-accent animate-spin"
              />

              <p className="text-[#bfbfbf] font-medium px-8 text-[14px] w-full text-center">
                Your next Spin starts in
              </p>
              <span className="text-[34px] font-semibold">
                {timeRemaining.hours}h : {timeRemaining.minutes}m :{" "}
                {timeRemaining.seconds}s
              </span>
            </div>

            <div className="w-full flex justify-between items-center gap-2 px-4">
              <div className="w-[47%] h-[2px] bg-cards2"></div>
              <span className="">or</span>
              <div className="w-[47%] h-[2px] bg-cards2"></div>
            </div>
            <div className="w-full flex justify-center items-center flex-col space-y-2 pb-7">
              <button
                onClick={() => setOpenUpgradeTwo(true)}
                className="bg-btn4 w-full py-[18px] px-6 text-nowrap flex items-center justify-center text-center rounded-[12px] font-semibold text-[17px]"
              >
                Buy more Spins
              </button>
            </div>
          </div>
        </div>
      </div>

      {/*  */}

      <div className="w-full absolute top-[50px] flex justify-center z-50 pointer-events-none select-none">
        {congrats ? (
          <img src="/congrats.gif" alt="congrats" className="w-[80%]" />
        ) : (
          <></>
        )}
      </div>

      <div
        className={`${
          openClaim === true ? "visible" : "invisible"
        } fixed top-[-12px] claimdiv bottom-0 left-0 z-40 right-0 h-[100vh] bg-[#00000042] flex flex-col justify-center items-center px-4`}
      >
        <div
          className={`${
            openClaim === true ? "opacity-100 mt-0" : "opacity-0 mt-[100px]"
          } w-full bg-modal rounded-[16px] relative flex flex-col ease-in duration-300 transition-all justify-center p-8`}
        >
          <div className="w-full flex justify-center flex-col items-center space-y-3">
            <div className="w-full items-center justify-center flex flex-col space-y-2">
              <IoCheckmarkCircleSharp size={32} className="text-accent" />
              <p className="font-medium">Let's go!!</p>
            </div>
            <h3 className="font-medium text-[24px] text-[#ffffff] pt-2 pb-2">
              <span className="text-accent text-center">{msg}</span>
            </h3>
            <p className="pb-6 text-[#bfbfbf] text-[15px] w-full text-center">
              Keep grinding! something huge is coming! Get more Rewards now!
            </p>

            <div className="w-full flex justify-center">
              <button
                onClick={closeClaimer}
                className="bg-btn4 w-fit py-[10px] px-6 flex items-center justify-center text-center rounded-[12px] font-medium text-[16px]"
              >
                Spin more!
              </button>
            </div>
          </div>
        </div>
      </div>
      {/*  */}

      {openUpgradeTwo && (
        <>
          <div className="fixed flex bottom-0 left-0 z-40 right-0 h-[100vh] bg-[#303030c4] flex-col justify-end items-center">
            <div className="w-full bg-divider shadowtop rounded-tl-[40px] rounded-tr-[40px] relative flex flex-col ease-in duration-300 transition-all justify-center">
              <div className="w-full flex taskbg rounded-tl-[40px] rounded-tr-[40px] mt-[2px] justify-center relative flex-col items-center space-y-3 p-4 pt-20 pb-10">
                <button
                  onClick={() => setOpenUpgradeTwo(false)}
                  className="flex items-center justify-center h-[32px] w-[32px] rounded-full bg-[#383838] absolute right-6 top-4 text-center font-medium text-[16px]"
                >
                  <IoClose size={20} className="text-[#9995a4]" />
                </button>

                <div className="w-full flex justify-center flex-col items-center">
                  <div className="w-[80px] h-[80px] rounded-[25px] flex items-center justify-center">
                    <img src="boost.webp" alt="dfd" className="w-[80px]" />
                  </div>
                  <h3 className="font-semibold text-center text-[24px]">
                    BUY MORE SPINS
                  </h3>
                  <p className="pb-6 text-primary text-[14px] px-4 text-center">
                    Get more spins to earn more points rewards and anticipate
                    airdrop and listing!
                  </p>

                  {/* Tab Interface */}
                  <div className="w-full flex flex-col justify-center items-center space-y-2 pb-6 max-w-[300px]">
                    {/* 20 spins */}
                    <button
                      className={`px-4 py-2 rounded-lg font-semibold text-[15px] transition-colors w-full ${
                        selectedOption === "20"
                          ? "bg-[#383838] text-white"
                          : "bg-[#4e4e4e] text-[#b7b7b7]"
                      }`}
                      onClick={() => setSelectedOption("20")}
                    >
                      <div className="flex items-center justify-center w-full space-x-1 font-semibold text-[15px] px-4 text-center">
                        <span>20 Spins:</span>
                        <span className="pl-1">
                          <img
                            src="ton.png"
                            alt="dfd"
                            className="w-[14px] h-[14px]"
                          />
                        </span>
                        <span>0.5</span>
                        <span>TON</span>
                      </div>
                    </button>
                    {/* 50 spins */}
                    <button
                      className={`px-4 py-2 rounded-lg font-semibold text-[15px] transition-colors w-full ${
                        selectedOption === "50"
                          ? "bg-[#383838] text-white"
                          : "bg-[#4e4e4e] text-[#b7b7b7]"
                      }`}
                      onClick={() => setSelectedOption("50")}
                    >
                      <div className=" flex items-center justify-center w-full space-x-1 font-semibold text-[15px] px-4 text-center">
                        <span>50 Spins:</span>
                        <span className="pl-1">
                          <img
                            src="ton.png"
                            alt="dfd"
                            className="w-[14px] h-[14px]"
                          />
                        </span>
                        <span>1</span>
                        <span>TON</span>
                      </div>
                    </button>
                    {/* 500 spins */}
                    <button
                      className={`px-4 py-2 rounded-lg font-semibold text-[15px] transition-colors w-full ${
                        selectedOption === "500"
                          ? "bg-[#383838] text-white"
                          : "bg-[#4e4e4e] text-[#b7b7b7]"
                      }`}
                      onClick={() => setSelectedOption("500")}
                    >
                      <div className=" flex flex-col items-center justify-center w-full space-x-1 font-semibold text-[15px] px-4 text-center">
                        <div className="flex space-x-1 items-center justify-center">
                          <span>500 Spins:</span>
                          <span className="pl-1">
                            <img
                              src="ton.png"
                              alt="dfd"
                              className="w-[14px] h-[14px]"
                            />
                          </span>
                          <span className="text-green-500">3</span>
                          <span className="line-through text-[#777]">5</span>
                          <span>TON</span>
                        </div>
                        <div className="text-[12px]">
                          for a limited time, 3 Tons instead of 5 Tons
                        </div>
                      </div>
                    </button>
                  </div>
                </div>

                {wallet ? (
                  <>
                    <div className="w-full flex justify-center items-center flex-col space-y-2 pb-7">
                      <button
                        onClick={handlePurchase}
                        className={`${
                          buttonDisabled ? "bg-[#5A4420]" : "bg-btn4"
                        } text-[#000] w-full py-[18px] px-6 text-nowrap flex items-center justify-center text-center rounded-[12px] font-semibold text-[17px]`}
                        disabled={buttonDisabled}
                      >
                        {buttonText}
                      </button>
                    </div>

                    {message && (
                      <p style={{ color: messageColor, marginTop: "10px" }}>
                        {message}
                      </p>
                    )}
                  </>
                ) : (
                  <div className="w-full flex flex-col items-center justify-center space-y-4">
                    <TonConnectButton className="!w-full" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}

      <div
        className={`${
          showCongratsModal === true ? "visible" : "invisible"
        } fixed top-[-12px] bottom-0 left-0 z-40 right-0 h-[100vh] bg-[#00000042] flex justify-center items-center backdrop-blur-[6px] px-4`}
      >
        <div
          className={`${
            showCongratsModal === true
              ? "opacity-100 mt-0 ease-in duration-300"
              : "opacity-0 mt-[100px]"
          } w-full bg-modal relative rounded-[16px] flex flex-col justify-center p-8`}
        >
          {congratsMessage}

          <div className="w-full flex justify-center">
            <button
              onClick={() => {
                setShowCongratsModal(false);
                setOpenUpgradeTwo(false);
              }}
              className={`bg-btn4 w-full py-[16px] px-6 flex items-center justify-center text-center rounded-[12px] font-medium text-[16px]`}
            >
              Start spinning
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SlotMachine;
